module.exports = __webpack_public_path__ + "img/name.724d96e7.png";